import { IAppNotifications, IAppCallouts } from "store/app/types";
import { AppActionKeys } from "store/app/keys";
import { NotificationCalloutDto } from "models/ApiModels";


export function updateNotificationCounter(counter: number): IAppNotifications {
    return {
        type: AppActionKeys.NOTIFICATION,
        counter: counter
    }
}

export function updateAppCallouts(callouts: NotificationCalloutDto[]): IAppCallouts {
    return {
        type: AppActionKeys.CALLOUTS,
        payload: callouts
    }
}
